/** Normalise Furp API Result envelopes (lowercased by middleware on most routes). */
export function apiData<T = any>(payload: any): T | null {
  if (payload == null) return null;
  if (payload.data !== undefined) return payload.data as T;
  if (payload.Data !== undefined) return payload.Data as T;
  return payload as T;
}

export function apiFailed(res: any): boolean {
  if (res?.error) return true;
  const p = res?.payload;
  if (!p) return false;
  const rt = String(p.responseType ?? p.ResponseType ?? "").toLowerCase();
  if (rt === "error") return true;
  const code = p.code ?? p.Code;
  return code != null && code !== 200;
}

export function apiMessage(res: any, fallback = "Something went wrong."): string {
  if (typeof res?.payload === "string" && res.payload.trim()) return res.payload;
  if (typeof res?.error === "string") return res.error;
  if (res?.error?.message) return res.error.message;
  const p = res?.payload;
  const msg = p?.message ?? p?.Message;
  if (msg) return msg;
  const messages = p?.messages ?? p?.Messages;
  if (Array.isArray(messages) && messages[0]) return messages[0];
  return fallback;
}
